
export default {
  name: "UserBox",
  mounted() { },
  created() { },
  activated: function (el) { },
  deactivated() { },
  methods: {
    logout() {
      localStorage.removeItem('_m');
      location.reload();
    }
  },
  data() {
    return {};
  },
};
